module.exports = __webpack_public_path__ + "static/media/icon-info-grey.a28d0ba1.svg";